import { motion } from 'framer-motion';

export default function PrimaryButton({ text, href }: { text: string; href: string }) {
  return (
    <motion.a
      href={href}
      className="bg-rose-400 text-white px-6 py-3 rounded-full text-lg font-semibold shadow-lg relative overflow-hidden"
      whileHover={{ 
        scale: 1.05,
        boxShadow: "0 10px 25px rgba(244, 63, 94, 0.3)"
      }}
      whileTap={{ scale: 0.95 }}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ 
        duration: 0.3,
        ease: "easeOut"
      }}
    >
      {/* Text content */}
      <span className="relative z-10">{text}</span>
      
      {/* Subtle pulse effect - positioned absolutely behind content */}
      <motion.div
        className="absolute inset-0 rounded-full bg-rose-300 -z-10"
        animate={{ 
          scale: [1, 1.1, 1],
          opacity: [0.3, 0, 0.3]
        }}
        transition={{ 
          duration: 2,
          repeat: Infinity,
          ease: "easeInOut"
        }}
      />
    </motion.a>
  );
}